import { SidebarMenu } from "../../../enum/SidebarMenu";

import { clearLocalStorage } from '../../local-storage';

import { clearSessionStorage } from "../../session-storage";

import icon from "../../../assets/img/svg/sidebar/user-avatar.svg";

export const user = {
  sidebarMenuType: SidebarMenu.USER,
  label: "sidebar.user.title",
  path: undefined,
  routes: [
    {
      label: "sidebar.user.logout",
      path: `/login`,
      onClick: () => {
        clearSessionStorage();
        clearLocalStorage();
      },
    },
  ],
  icon: icon,
};
